type Quote = {
  image: string;
  name: string;
  position: string;
  text: string;
};

export const quotes: Quote[] = [
  {
    text: 'Working with Beam has opened exciting opportunities in AI and RWA integration, strengthening our collaborative vision for the future.',
    name: 'Mark Rydon',
    position: 'Co-Founder of Aethir',
    image: '/images/quotes/mark.png',
  },
  {
    text: 'Beam let us skip the Web3 headaches and focus on gameplay. That’s how we can ship a frictionless, mobile racing experience players actually enjoy.',
    name: 'Doron Kagan',
    position: 'CEO and Co-Founder of TrialXtreme',
    image: '/images/quotes/doron.png',
  },
  {
    text: 'Beam provided the initial push for Sophon and our continued relation remains invaluable to our growth.',
    name: 'Sebastien',
    position: 'CEO of Sophon',
    image: '/images/quotes/sebastien.png',
  },
  {
    text: "Beam's kickstart gave us the momentum we needed; now we're operating independently while maintaining our valuable relationship.",
    name: 'Apran',
    position: 'CEO and Co-Founder of Noon Capital',
    image: '/images/quotes/apran.png',
  },
  {
    text: 'From friendship to strategic alliance, Beam has been our steadfast partner in advancing gaming and pioneering new technologies together.',
    name: 'Jarindr',
    position: 'CEO and Co-Founder of Zentry',
    image: '/images/quotes/jarindr.png',
  },
  {
    text: 'Beam helped us revolutionize the memecoin space through our merger and continues to support us with all of our marketing.',
    name: 'Caps',
    position: 'Co-Founder of Flayer',
    image: '/images/quotes/caps.png',
  },
];
